import React, { createContext, useState } from 'react';

// Créer le contexte
export const PartnerContext = createContext();

// Fournisseur du contexte
export const PartnerProvider = ({ children }) => {
  const [partner, setPartner] = useState(null);
  const [showPositionForm, setShowPositionForm] = useState(false);
  const [positionFormData, setPositionFormData] = useState({
    title: '',
    description: '',
    experience: 0,
    skills: '',
    location: '',
    salary: '',
    contractType: '',
    applicationLink: '',
  });

  // Autres états si nécessaires
  const [editFormData, setEditFormData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  return (
    <PartnerContext.Provider
      value={{
        partner,
        setPartner,
        showPositionForm,
        setShowPositionForm,
        positionFormData,
        setPositionFormData,
        editFormData,
        setEditFormData,
        isEditing,
        setIsEditing,
      }}
    >
      {children}
    </PartnerContext.Provider>
  );
};